// extracted by mini-css-extract-plugin
export default {"Alergen":"AlergenCard_Alergen__VCiJR","Tooltip":"AlergenCard_Tooltip__34SQF"};